module.exports = __webpack_public_path__ + "img/staff.c7e0f24d.png";